import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import Base from '../../utils/base'
import moment from "moment";

export default function Blog(props) {
  var base = new Base()
  const {t, i18n} = useTranslation()

  const momentNow = moment()
  const [arrArticle, setArrArticle] = useState([
    // {
    //   id: '',
    //   image: 'assets/images/blog/blog-1-1.jpg?rnd=' + momentNow.format('HHmmss'),
    //   title: 'Check the Top 6 luxury Hotels in the World',
    //   date: moment(),
    //   user: {
    //     name: 'Admin',
    //   },
    //   subtitle: 'It is a long established fact that a reader will be distred by the readable',
    //   totalComment: 2,
    // },
    // {
    //   id: '',
    //   image: 'assets/images/blog/blog-1-2.jpg?rnd=' + momentNow.format('HHmmss'),
    //   title: "Lorem Ipsum has been the industry's standard",
    //   date: moment().subtract(1, 'months'),
    //   user: {
    //     name: 'Admin',
    //   },
    //   subtitle: 'It is a long established fact that a reader will be distred by the readable',
    //   totalComment: 2,
    // },
    // {
    //   id: '',
    //   image: 'assets/images/blog/blog-1-3.jpg?rnd=' + momentNow.format('HHmmss'),
    //   title: 'Software like Aldus PageMaker including versions',
    //   date: moment().subtract(2, 'months'),
    //   user: {
    //     name: 'Admin',
    //   },
    //   subtitle: 'It is a long established fact that a reader will be distred by the readable',
    //   totalComment: 2,
    // },
    // {
    //   id: '',
    //   image: 'assets/images/blog/blog-1-1.jpg?rnd=' + momentNow.format('HHmmss'),
    //   title: 'Check the Top 6 luxury Hotels in the World',
    //   date: moment(),
    //   user: {
    //     name: 'Admin',
    //   },
    //   subtitle: 'It is a long established fact that a reader will be distred by the readable',
    //   totalComment: 2,
    // },
    // {
    //   id: '',
    //   image: 'assets/images/blog/blog-1-2.jpg?rnd=' + momentNow.format('HHmmss'),
    //   title: "Lorem Ipsum has been the industry's standard",
    //   date: moment().subtract(1, 'months'),
    //   user: {
    //     name: 'Admin',
    //   },
    //   subtitle: 'It is a long established fact that a reader will be distred by the readable',
    //   totalComment: 2,
    // },
    // {
    //   id: '',
    //   image: 'assets/images/blog/blog-1-3.jpg?rnd=' + momentNow.format('HHmmss'),
    //   title: 'Software like Aldus PageMaker including versions',
    //   date: moment().subtract(2, 'months'),
    //   user: {
    //     name: 'Admin',
    //   },
    //   subtitle: 'It is a long established fact that a reader will be distred by the readable',
    //   totalComment: 2,
    // },
  ])
  const [infoData, setInfoData] = useState({})

  useEffect(() => {
    var lang = window.localStorage.getItem('lang')
		i18n.changeLanguage(lang != null ? lang : 'en')

    get_data()
    get_info_data()
  }, [])
  
  async function get_data() {
    var response = await base.request(base.url_api + "/article/all")

    if(response != null){
      if(response.status == "success"){
        for(let data of response.data){
          data.image = data.url_image
          data.subtitle = data.content
          data.date = moment(data.created_at)
        }
        // console.log(response.data)
        setArrArticle(response.data)
      }
      else
        base.show_error(response.message)
    }
    else
      console.log('Server Error')
  }

  async function get_info_data() {
    var response = await base.request(base.url_api + "/info?type=home_article")

    if(response != null){
      if(response.status == "success"){
        setInfoData(response.data)
      }
      else
        base.show_error(response.message)
    }
    else
      console.log('Server Error')
  }

  return (
    <section class="blog-one">
      <div class="container">
        <div class="sec-title text-center">

          {/* <img src="assets/images/shapes/sec-title-s-1.png" alt="Latest Article" class="sec-title__img" /> */}


          <h6 class="sec-title__tagline bw-split-in-right" style={{ fontSize: '.8rem', }}>{infoData.title}</h6>

          <h3 class="sec-title__title bw-split-in-up text-uppercase" style={{ fontSize: '3.125rem', }}>{infoData.subtitle}</h3>
        </div>

        <div class="row gutter-y-30">
          {
            arrArticle.map((article, index) => (
              <div class="col-md-6 col-lg-4">
                <div class="blog-card wow fadeInUp" data-wow-duration='1500ms' data-wow-delay='000ms'>
                  <div class="blog-card__image">
                    <div class="blog-card__image__inner">
                      <img src={article.image} alt={article.title}  style={{ height: '300px', }}/>
                      <img src={article.image} alt={article.title} style={{ height: '300px', }}/>
                      <a href={"/article?id=" + article.id} class="blog-card__image__inner__link"><span class="sr-only">{article.title}</span></a>
                      <div class="blog-card__date" style={{ fontSize: '.8rem', }}><span style={{ fontSize: '1.875rem', }}>{article.date.format('DD')}</span> {article.date.format('MMMM')}</div>
                    </div>
                    <ul class="list-unstyled blog-card__meta">
                      {/* <li><a href="blog-list.html"> <i class="icon-user"></i> by {article.user.name}</a></li> */}
                      {/* <li><a href="blog-details-right.html"> <i class="icon-bubble-chat"></i>{article.totalComment.toLocaleString(base.locale_string)} Comments</a></li> */}
                    </ul>
                  </div>
                  <div class="blog-card__content">
                    <h3 class="blog-card__title" style={{ fontSize: '1.4rem', }}><a href={"/article?id=" + article.id}>{base.capitalizeFirstLetter(article.title)}</a></h3>
                    <p class="blog-card__text text-truncate" style={{ fontSize: '1rem', }}>{base.capitalizeFirstLetter(article.subtitle)}</p>
                    <div class="blog-card__link">
                      <a href={"/article?id=" + article.id} class="solinom-btn" style={{ fontSize: '1rem', }}>{t('read_more')}</a>
                    </div>
                  </div>
                </div>
              </div>
            ))
          }
        </div>
      </div>
      <div class="reviews-one__line"></div>
    </section>
  );
};
